<div class="content-option-row">
  <div class="content-option-row-label" translate>Every</div>
  <rotec-number-input-panel-v2
    class="number-input-panel"
    [darkMode]="true"
    [min]="1"
    [value]="interval"
    (valueChange)="changeInterval($event)"
  ></rotec-number-input-panel-v2>
  <div class="label-spacing" translate>Year(s)</div>
</div>

<div class="content-option-row margin-top-20">
  <div class="content-select">
    <rotec-radio-group-v2
      [darkMode]="true"
      [options]="intervalTypeItems"
      [selected]="isIntervalExact"
      (selectedChange)="intervalTypeChange($event)"
    ></rotec-radio-group-v2>
  </div>
  @if (isIntervalExact) {
    <div class="content-option-row">
      <rotec-number-input-panel-v2
        class="number-input-panel"
        [darkMode]="true"
        [min]="1"
        [max]="lastDayOfMonth"
        [value]="intervalDate"
        (valueChange)="intervalDateChange($event)"
      ></rotec-number-input-panel-v2>
      <div class="label-spacing">,</div>
      <rotec-select-v2
        class="month-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="monthItems"
        [selectedItem]="monthValue"
        (selectedItemChange)="monthChange($event)"
      ></rotec-select-v2>
    </div>
  }
  @if (!isIntervalExact) {
    <div class="content-option-row">
      <rotec-select-v2
        class="interval-weeks-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="intervalWeeksItems"
        [selectedItem]="intervalWeek"
        (selectedItemChange)="weekChange($event)"
      ></rotec-select-v2>
      <div class="content-option-row-label">&nbsp;</div>
      <rotec-select-v2
        class="day-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="dayItems"
        [selectedItem]="dayValue"
        (selectedItemChange)="dayChange($event)"
      ></rotec-select-v2>
      <div class="label-spacing" translate>in</div>
      <rotec-select-v2
        class="month-select"
        [darkMode]="true"
        [secondary]="true"
        [items]="monthItems"
        [selectedItem]="monthValue"
        (selectedItemChange)="monthChange($event)"
      ></rotec-select-v2>
    </div>
  }
</div>
